<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<span class="int_type half_int">
					<autocomplete ref="ac" :initialDisplay="keyword" :source="selectClasses" @selected="selectClass" results-display="code_name" :placeholder="'Item / ' + headers.class + ' Name or Code'"> </autocomplete>
				</span>
			</div>
			<div class="left_option" style="padding-top:5px;">
				<span class="int_type_no_border mgr_5">
					<ItemClassSelectMulti v-model.trim="item_classes_string" />
				</span>
				<span class="int_type mgr_15">
					<select v-model="active_yn" class="tbl_select sm_int">
						<option v-for="tag in this.$activeTags" v-bind:value="tag.value" v-bind:key="tag.value">{{ tag.text }}</option>
					</select>
				</span>
				<span class="int_type mgr_5">
					<input type="text" v-model="keyword" placeholder="Enter Search Keyword" autofocus autocomplete="off" @keyup.enter="search()" />
				</span>
				<em class="lt_text">Back Order Occurrence Count &gt;= </em>
				<span class="int_type mgr_15 " style="width:60px;">
					<currency-input type="text" class="al_right" :precision="0" v-model="bo_count" autocomplete="off" @focus="$event.target.select()" />
				</span>
				<em class="lt_text">On Hand</em>
				<span class="int_type">
					<select v-model="on_hand_condition" class="tbl_select sm_int">
						<option :value="null"></option>
						<option value="less_than">&lt;</option>
						<option value="equal">=</option>
						<option value="greater_than">&gt;</option>
					</select>
				</span>
				<span class="int_type mgr_15 " style="width:60px;">
					<currency-input type="text" class="al_right" :precision="0" v-model="on_hand_quantity" autocomplete="off" @focus="$event.target.select()" />
				</span>
				<a href="javascript:;" class="search_bt" @click="search()">Search</a>
				<a href="javascript:;" class="gray_bt" @click="reset()">Reset</a>
			</div>
		</div>
		<table id="item_list" class="list_tbl tbl_pointer" v-columns-resizable>
			<thead>
				<tr>
					<th width="30px;"><input type="checkbox" @change="selectAll()" v-model="allSelected" /></th>
					<th style="text-align:center;width:150px;">Location</th>
					<th style="text-align:center;width:50px;">Rack</th>
					<th style="text-align:center;width:50px;">Sec.</th>
					<th style="text-align:center;width:200px;">{{ headers.class }} Code</th>
					<th style="text-align:center;width:150px;">Color</th>
					<th v-if="user.company_id == 'newjigu'">Item Name</th>
					<th v-else>{{ headers.class }} Name</th>
					<th style="text-align:center;width:120px;">Barcode</th>
					<th style="text-align:center;width:120px;font-weight:bold;color:red;">Back Order Occurrence Count</th>
					<th style="text-align:center;width:100px;">On Hand</th>
					<th style="text-align:center;width:50px;">Active</th>
				</tr>
			</thead>

			<tbody>
				<tr v-for="(item, index) in items" v-bind:key="item.item_id">
					<td class="al_center"><input type="checkbox" v-model="item.selected" /></td>
					<td>{{ item.location_name }}</td>
					<td>{{ item.rack }}</td>
					<td>{{ item.section }}</td>
					<td>
						<!-- {{ item.class_code }} -->
						<template v-if="index == 0 || (index > 0 && item.class_code != items[index - 1].class_code)">
							{{ item.class_code }}
						</template>
					</td>
					<td>{{ item.color_code }}</td>
					<td v-if="user.company_id == 'newjigu'" class="al_left truncate">{{ item.name }}</td>
					<td v-else class="al_left truncate">{{ item.class_name }}</td>
					<td>{{ item.barcode }}</td>
					<td style="text-align:right;font-weight:bold;color:red;">{{ item.bo_count | commaSeparated }}</td>
					<td style="text-align:right;">
						<!-- {{ item.on_hand | commaSeparated }} -->
						<currency-input type="text" :style="item.changed ? 'border:1px solid red' : 'border:1px solid #ddd'" v-model.trim="item.new_on_hand" :precision="0" class="r_int long_type al_right" @focus="$event.target.select()" />
					</td>
					<td style="text-align:center;">{{ item.active_yn }}</td>
				</tr>
			</tbody>
		</table>

		<div style="text-align:right;padding-top:5px;padding-right:10px;">Total Count : {{ list_count | commaSeparated }}</div>

		<Paging ref="paging" v-on:gotoPage="gotoPage"></Paging>

		<div class="view_bottom_bt">
			<a href="javascript:;" class="gray_bt" style="margin-right:15px" @click="print(true)">Print All</a>
			<a href="javascript:;" class="gray_bt" style="margin-right:15px" @click="print(false)">Print Only Selected</a>
			<span v-if="modifiable" class="int_type mgr_5">
				<select v-model="adjust_reason" class="tbl_select sm_int">
					<option value="adjust">Inventory Adjust</option>
					<option value="damage">Damage Loss</option>
					<option value="missing">Missing</option>
				</select>
			</span>
			<a v-if="modifiable" href="javascript:;" class="gray_bt" style="margin-right:15px" @click="adjustInventory()">Adjust On-Hand</a>
			<a v-if="modifiable" href="javascript:;" class="search_bt" style="margin-right:15px" @click="resetBarckOrderCount()">Reset Back Order Occurrence Count</a>
		</div>
	</div>
</template>

<script>
import { apiSelectItemList, apiResetBackOrderCountBatch } from '@/api/item/master.js';
import { apiAdjustBatch } from '@/api/item/inventory.js';
import { Report, reportMrtUrl, apiGetReportTemplate, PrintType } from '@/api/util';

import ItemClassSelectMulti from '@/components/common/ItemClassSelectMulti';
import Paging from '@/components/common/Paging';
// import { exportDataExcel, objectToFormData } from '@/api/util';
// import { defaultDataType } from 'export-xlsx';

export default {
	data: function() {
		return {
			uri: null,
			backUri: '/',
			paging_yn: 'Y',
			page_size: 26,
			page_no: 1,
			list_count: 0,
			active_yn: 'Y',
			saveParam: {},
			items: [],
			exportItems: [],

			item_classes_string: '',
			item_classes: [],

			adjust_reason: null,

			bo_count: 1,
			keyword: null,
			allSelected: false,

			on_hand_condition: null,
			on_hand_quantity: 0,
		};
	},
	props: ['headers'],
	watch: {
		items: {
			deep: true,
			handler: function() {
				this.items.forEach(function(item) {
					if (item.on_hand != item.new_on_hand) item.changed = true;
					else item.changed = false;

					//console.log(item);
				});
			},
		},
	},
	computed: {
		user: function() {
			return this.$session.get('user');
		},
		profile: function() {
			return this.$session.get('profile');
		},
		modifiable() {
			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				// if (menus[i].path == this.$router.history.current.path && menus[i].modify_yn == 'Y') return true;
				if ((menus[i].path == this.$router.history.current.path || menus[i].path == this.$router.history.current.path.replace('add', 'detail')) && menus[i].modify_yn == 'Y') return true;
			}
			return false;
		},
	},
	components: {
		Paging,
		ItemClassSelectMulti,
	},
	methods: {
		async resetBarckOrderCount() {
			if (this.items.filter(i => i.selected).length == 0) {
				this.$toast.error('Nothing to reset');
				return;
			}

			var param = {
				items: this.items.filter(i => i.selected),
			};

			const { data } = await apiResetBackOrderCountBatch(param);

			if (data.result) {
				this.$toast.success('Saved successfully');
				this.selectItems();
			} else {
				this.$toast.error(data.msg);
			}
		},
		async adjustInventory() {
			var item_data = [];
			this.items.forEach(function(item) {
				if (item.changed) {
					var param_item = {
						item_id: item.item_id,
						before_quantity: item.on_hand,
						after_quantity: item.new_on_hand,
					};

					if (!param_item.before_quantity) param_item.before_quantity = 0;
					if (!param_item.after_quantity) param_item.after_quantity = 0;

					item_data.push(param_item);
				}
			});

			if (item_data.length == 0) {
				this.$toast.error('Nothing to adjust');
				return;
			}

			if (!this.adjust_reason) {
				this.$toast.error('Select reason');
				return;
			}

			var param = {
				adjust_reason: this.adjust_reason,
				items: item_data,
			};
			//console.log(param);
			const { data } = await apiAdjustBatch(param);

			if (data.result) {
				this.$toast.success('Saved successfully');
				this.selectItems();
			} else {
				this.$toast.error(data.msg);
			}
		},
		selectAll() {
			var vm = this;
			this.items.forEach(function(item) {
				item.selected = vm.allSelected;
			});
		},
		selectClasses(input) {
			var url = process.env.VUE_APP_API_URL + '/api/item/item_class/acClassList?company_id=' + this.user.company_id + '&include_closed_yn=Y&keyword=' + input;
			return url;
		},
		selectClass(c) {
			this.$refs.ac.clear();
			if (this.item_classes_string) this.item_classes_string += ', ' + c.selectedObject.code;
			else this.item_classes_string = c.selectedObject.code;
		},
		search() {
			if (this.item_classes_string) this.item_classes = this.item_classes_string.split(',');
			else this.item_classes = [];
			//console.log(this.item_classes);

			this.selectItems();
		},
		reset() {
			this.page_no = 1;
			this.keyword = '';
			this.active_yn = 'Y';

			this.item_classes_string = '';
			this.item_classes = [];
			this.allSelected = false;

			this.on_hand_condition = null;
			this.on_hand_quantity = 0;
		},
		selectShipment(sh_no) {
			let routeData = this.$router.resolve({
				name: 'shipmentDetail',
				params: { mode: 'detail' },
				query: { backUri: this.uri, sh_no: sh_no },
			});
			window.open(routeData.href, '_blank');
		},
		async print(all) {
			var toPrintItemList = [];

			if (all) {
				const { data } = await apiSelectItemList(this.saveParam);
				if (!(data && Array.isArray(data.itemList))) {
					this.$toast.error('No Data to be Shown.');
					return;
				}
				toPrintItemList = data.itemList;
			} else {
				toPrintItemList = this.items.filter(i => i.selected);
			}
			const result = {
				print_time: this.$moment(new Date()).format('MM-DD-YYYY HH:mm:ss'),
				print_user: this.user.user_id,
				//data: data.itemList.map(el => this.getSimpleItemInfo(el)),
				data: toPrintItemList.map(el => this.getSimpleItemInfo(el)),
			};

			const reportTemplate = await apiGetReportTemplate('InventoryCounting', reportMrtUrl('InventoryCounting'));
			const report = new Report(reportTemplate, result, 'InventoryCounting', PrintType.Normal);
			this.$store.commit('setReport', report);
		},
		getSimpleItemInfo(item) {
			return {
				item_id: item.item_id,
				item_code: item.item_code,
				name: item.name,
				class_code: item.class_code,
				class_name: item.class_name,
				color_code: item.color_code,
				location_code: item.location_code,
				location_name: item.location_name,
				on_hand: item.on_hand,
				new_on_hand: item.new_on_hand,
				rack: item.rack,
				section: item.section,
			};
		},
		gotoPage(pageNo) {
			this.selectItems(pageNo);
		},
		async selectItems(pageNo) {
			if (pageNo) this.page_no = pageNo;
			else this.page_no = 1;
			this.mode = 'detail';
			this.item = {};
			this.selectedItem = {};

			var param = {
				paging_yn: this.paging_yn,
				page_size: this.page_size,
				page_no: this.page_no,
				start_index: this.page_size * (this.page_no - 1),

				bo_count: this.bo_count,
				keyword: this.keyword,
				item_classes: this.item_classes,
				active_yn: this.active_yn,
				on_hand_condition: this.on_hand_condition,
				on_hand_quantity: this.on_hand_quantity,

				order: 'location',
			};

			this.saveParam = {
				paging_yn: 'N',

				bo_count: this.bo_count,
				keyword: this.keyword,
				item_classes: [...this.item_classes],
				active_yn: this.active_yn,
				on_hand_condition: this.on_hand_condition,
				on_hand_quantity: this.on_hand_quantity,

				order: 'location',
			};

			const { data } = await apiSelectItemList(param);

			this.allSelected = false;
			this.items = data.itemList;

			this.list_count = data.list_count;

			this.$refs.paging.setPage(this.page_no, this.page_size, this.list_count);
		},
	},
	created() {
		if (this.$route.query.backUri) this.backUri = this.$route.query.backUri;

		this.$store.commit('setSideIndex', 1);
		this.$store.commit('setSelectedMenu', 'nav_li_inventory_counting');
		this.$store.commit('setSubTitle', 'Item -> Inventory Counting');

		//console.log(this.profile);
		this.bo_count = this.profile.backorder_lock_count;

		this.selectItems();
	},
};
</script>

<style></style>
